export const STORAGE_KEYS = {
  REFRESH_TOKEN: 'refreshToken',
  ACCESS_TOKEN_EXPIRE: 'accessTokenExpTimestamp',
  REFRESH_GRAPHQL_TOKEN: 'refreshGraphqlToken',
  ACCESS_GRAPHQL_TOKEN_EXPIRE: 'accessGraphqlTokenExpTimestamp',
  THEME_NAME: 'theme',
};
